import 'ngstorage';
const MODULE_NAME = 'gazdalkodasiKalkulatorService';
class GazdalkodasiKalkulatorService {
	constructor($http, environment, $q, $sessionStorage) {
		'ngInject';
		this._environment = environment;
		this._$q = $q;
		this._$sessionStorage = $sessionStorage;
		this._apiRoot = $http({
			url: `${environment.backendUrl}/do/proxy/b`
		});

	}
	init() {
		return this._$q.all([this._getNovenyek(), this._getTalajok(), this._getTermesztesiSzinvonalak()]);
	}
	putModelData(eredmenyModel, gepiMunkak) {
		let model = {
			eredmenyModel: eredmenyModel,
			gepiMunkak: gepiMunkak
		};
		this._$sessionStorage.calculationModelData = model;
	}
	getModelData() {
		return this._$sessionStorage.calculationModelData;
	}

	_getNovenyek() {
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$get('novenyek', { page: 0, size: 9999 });
		}).then((resp) => {
			return resp.$hasEmbedded('novenyek') ? resp.$request().$get('novenyek') : [];
		}, () => {
			return this._$q.reject();
		});
	}
	_getTalajok() {
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$get('talajok', { page: 0, size: 9999 });
		}).then((resp) => {
			return resp.$hasEmbedded('talajok') ? resp.$request().$get('talajok') : [];
		}, () => {
			return this._$q.reject();
		});
	}
	_getTermesztesiSzinvonalak() {
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$get('termesztesiSzinvonalak', { page: 0, size: 9999 });
		}).then((resp) => {
			return resp.$hasEmbedded('termesztesiSzinvonalak') ? resp.$request().$get('termesztesiSzinvonalak') : [];
		}, () => {
			return this._$q.reject();
		});
	}
	kalkulal(model) {
		return this._apiRoot.then((apiRoot) => {
			return apiRoot.$request().$post('gazdalkodasiKalkulacioKeresek', null, model);
		}).then((resp) => {
			return resp;
		}, (err) => {
			return this._$q.reject(err);
		});
	}
}

export default angular.module(MODULE_NAME, ['ngStorage'])
	.service('gazdalkodasiKalkulatorService', GazdalkodasiKalkulatorService).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/gazdalkodasikalkulator/gazdalkodasikalkulator-service.js